import { FETCH_USER_ROLE_SUCCESS } from '../actions/types/UserActionTypes';
import { AUTH_LOGOUT } from '../../../redux/actions/types/authActionTypes';

export const initialState = {
  userRole: '',
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
  case FETCH_USER_ROLE_SUCCESS:
    return {
      ...state,
      userRole: action.payload,
    };
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};

export default userReducer;
